import { emptySplitApi as api } from './index'
export const addTagTypes = [
  'Auth',
  'Login',
  'SignUp',
  'VerifyEmail',
  'ForgotPassword',
  'ResetPassword',
  'VerifyEmailChange',
  'Session',
  'Logout',
  'UpdateUserProfileDetails',
  'UpdateUserPassword',
  'UpdateUserProfilePicture',
  'Components',
  'CreateComponent',
  'CreateTBoltGroup',
  'UpdateComponent',
  'DeleteComponent',
  'ReplaceCastInChannel',
  'ReplaceTBolt',
  'Customers',
  'ListCustomers',
  'CreateCustomer',
  'ShowCustomer',
  'UpdateCustomer',
  'DeleteCustomer',
  'Designs',
  'ListDesigns',
  'CreateDesign',
  'ListDesignsByProject',
  'ShowDesign',
  'DeleteDesign',
  ' Product Variants',
  'UpdateDesign',
  'DuplicateDesign',
  'ReassignDesign',
  'ValidateDesign',
  'Product Variants',
  'ListProductVariants',
  'Products',
  'ListProducts',
  'Projects',
  'ListProjects',
  'CreateProject',
  'ShowProject',
  'UpdateProject',
  'DeleteProject',
  'DuplicateProject',
  'Reports',
  'ShowReportPDF',
  'Substrates',
  'ListSubstrates',
  'Users',
  'ListCustomerUsers',
  'InviteCustomerUser',
  'ShowCustomerUser',
  'DeleteCustomerUsers',
  'UpdateCustomerUser',
] as const
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      postAuthLogin: build.mutation<
        PostAuthLoginApiResponse,
        PostAuthLoginApiArg
      >({
        query: (queryArg) => ({
          url: '/auth/login',
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['Auth', 'Login'],
      }),
      postAuthSignup: build.mutation<
        PostAuthSignupApiResponse,
        PostAuthSignupApiArg
      >({
        query: (queryArg) => ({
          url: '/auth/signup',
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['Auth', 'SignUp'],
      }),
      postAuthVerifyEmail: build.mutation<
        PostAuthVerifyEmailApiResponse,
        PostAuthVerifyEmailApiArg
      >({
        query: (queryArg) => ({
          url: '/auth/verify-email',
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['Auth', 'VerifyEmail'],
      }),
      postAuthForgotPassword: build.mutation<
        PostAuthForgotPasswordApiResponse,
        PostAuthForgotPasswordApiArg
      >({
        query: (queryArg) => ({
          url: '/auth/forgot-password',
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['Auth', 'ForgotPassword'],
      }),
      postAuthResetPassword: build.mutation<
        PostAuthResetPasswordApiResponse,
        PostAuthResetPasswordApiArg
      >({
        query: (queryArg) => ({
          url: '/auth/reset-password',
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['Auth', 'ResetPassword'],
      }),
      postProfileVerifyEmailChange: build.mutation<
        PostProfileVerifyEmailChangeApiResponse,
        PostProfileVerifyEmailChangeApiArg
      >({
        query: (queryArg) => ({
          url: '/profile/verify-email-change',
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['Auth', 'VerifyEmailChange'],
      }),
      getAuthSession: build.query<
        GetAuthSessionApiResponse,
        GetAuthSessionApiArg
      >({
        query: () => ({ url: '/auth/session' }),
        providesTags: ['Auth', 'Session'],
      }),
      deleteAuthLogout: build.mutation<
        DeleteAuthLogoutApiResponse,
        DeleteAuthLogoutApiArg
      >({
        query: (queryArg) => ({
          url: '/auth/logout',
          method: 'DELETE',
          body: queryArg.body,
        }),
        invalidatesTags: ['Auth', 'Logout'],
      }),
      patchProfileDetails: build.mutation<
        PatchProfileDetailsApiResponse,
        PatchProfileDetailsApiArg
      >({
        query: (queryArg) => ({
          url: '/profile/details',
          method: 'PATCH',
          body: queryArg.body,
        }),
        invalidatesTags: ['Auth', 'UpdateUserProfileDetails'],
      }),
      patchProfilePassword: build.mutation<
        PatchProfilePasswordApiResponse,
        PatchProfilePasswordApiArg
      >({
        query: (queryArg) => ({
          url: '/profile/password',
          method: 'PATCH',
          body: queryArg.body,
        }),
        invalidatesTags: ['Auth', 'UpdateUserPassword'],
      }),
      patchProfilePicture: build.mutation<
        PatchProfilePictureApiResponse,
        PatchProfilePictureApiArg
      >({
        query: (queryArg) => ({
          url: '/profile/picture',
          method: 'PATCH',
          body: queryArg.body,
        }),
        invalidatesTags: ['Auth', 'UpdateUserProfilePicture'],
      }),
      postComponents: build.mutation<
        PostComponentsApiResponse,
        PostComponentsApiArg
      >({
        query: (queryArg) => ({
          url: '/components',
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['Components', 'CreateComponent'],
      }),
      postComponentsTbGroup: build.mutation<
        PostComponentsTbGroupApiResponse,
        PostComponentsTbGroupApiArg
      >({
        query: (queryArg) => ({
          url: '/components/tb-group',
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['Components', 'CreateTBoltGroup'],
      }),
      patchComponentsByComponent: build.mutation<
        PatchComponentsByComponentApiResponse,
        PatchComponentsByComponentApiArg
      >({
        query: (queryArg) => ({
          url: `/components/${queryArg.component}`,
          method: 'PATCH',
          body: queryArg.body,
        }),
        invalidatesTags: ['Components', 'UpdateComponent'],
      }),
      deleteComponentsByComponent: build.mutation<
        DeleteComponentsByComponentApiResponse,
        DeleteComponentsByComponentApiArg
      >({
        query: (queryArg) => ({
          url: `/components/${queryArg.component}`,
          method: 'DELETE',
          body: queryArg.body,
        }),
        invalidatesTags: ['Components', 'DeleteComponent'],
      }),
      patchComponentsByComponentReplaceCastInChannel: build.mutation<
        PatchComponentsByComponentReplaceCastInChannelApiResponse,
        PatchComponentsByComponentReplaceCastInChannelApiArg
      >({
        query: (queryArg) => ({
          url: `/components/${queryArg.component}/replace-cast-in-channel`,
          method: 'PATCH',
          body: queryArg.body,
        }),
        invalidatesTags: ['Components', 'ReplaceCastInChannel'],
      }),
      patchComponentsByComponentReplaceTBolt: build.mutation<
        PatchComponentsByComponentReplaceTBoltApiResponse,
        PatchComponentsByComponentReplaceTBoltApiArg
      >({
        query: (queryArg) => ({
          url: `/components/${queryArg.component}/replace-t-bolt`,
          method: 'PATCH',
          body: queryArg.body,
        }),
        invalidatesTags: ['Components', 'ReplaceTBolt'],
      }),
      getCustomers: build.query<GetCustomersApiResponse, GetCustomersApiArg>({
        query: (queryArg) => ({
          url: '/customers',
          params: {
            search: queryArg.search,
            sortBy: queryArg.sortBy,
            sortDirection: queryArg.sortDirection,
            page: queryArg.page,
            perPage: queryArg.perPage,
          },
        }),
        providesTags: ['Customers', 'ListCustomers'],
      }),
      postCustomers: build.mutation<
        PostCustomersApiResponse,
        PostCustomersApiArg
      >({
        query: (queryArg) => ({
          url: '/customers',
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['Customers', 'CreateCustomer'],
      }),
      getCustomersByCustomer: build.query<
        GetCustomersByCustomerApiResponse,
        GetCustomersByCustomerApiArg
      >({
        query: (queryArg) => ({ url: `/customers/${queryArg.customer}` }),
        providesTags: ['Customers', 'ShowCustomer'],
      }),
      patchCustomersByCustomer: build.mutation<
        PatchCustomersByCustomerApiResponse,
        PatchCustomersByCustomerApiArg
      >({
        query: (queryArg) => ({
          url: `/customers/${queryArg.customer}`,
          method: 'PATCH',
          body: queryArg.body,
        }),
        invalidatesTags: ['Customers', 'UpdateCustomer'],
      }),
      deleteCustomersByCustomer: build.mutation<
        DeleteCustomersByCustomerApiResponse,
        DeleteCustomersByCustomerApiArg
      >({
        query: (queryArg) => ({
          url: `/customers/${queryArg.customer}`,
          method: 'DELETE',
          body: queryArg.body,
        }),
        invalidatesTags: ['Customers', 'DeleteCustomer'],
      }),
      getDesigns: build.query<GetDesignsApiResponse, GetDesignsApiArg>({
        query: (queryArg) => ({
          url: '/designs',
          params: {
            projectId: queryArg.projectId,
            search: queryArg.search,
            sortBy: queryArg.sortBy,
            sortDirection: queryArg.sortDirection,
            page: queryArg.page,
            perPage: queryArg.perPage,
          },
        }),
        providesTags: ['Designs', 'ListDesigns'],
      }),
      postDesigns: build.mutation<PostDesignsApiResponse, PostDesignsApiArg>({
        query: (queryArg) => ({
          url: '/designs',
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['Designs', 'CreateDesign'],
      }),
      getDesignsGroupedByProjects: build.query<
        GetDesignsGroupedByProjectsApiResponse,
        GetDesignsGroupedByProjectsApiArg
      >({
        query: (queryArg) => ({
          url: '/designs/grouped-by-projects',
          params: {
            projectId: queryArg.projectId,
            search: queryArg.search,
            sortBy: queryArg.sortBy,
            sortDirection: queryArg.sortDirection,
            page: queryArg.page,
            perPage: queryArg.perPage,
          },
        }),
        providesTags: ['Designs', 'ListDesignsByProject'],
      }),
      getDesignsByDesign: build.query<
        GetDesignsByDesignApiResponse,
        GetDesignsByDesignApiArg
      >({
        query: (queryArg) => ({ url: `/designs/${queryArg.design}` }),
        providesTags: ['Designs', 'ShowDesign'],
      }),
      deleteDesignsByDesign: build.mutation<
        DeleteDesignsByDesignApiResponse,
        DeleteDesignsByDesignApiArg
      >({
        query: (queryArg) => ({
          url: `/designs/${queryArg.design}`,
          method: 'DELETE',
          body: queryArg.body,
        }),
        invalidatesTags: ['Designs', 'DeleteDesign'],
      }),
      patchDesignsByDesign: build.mutation<
        PatchDesignsByDesignApiResponse,
        PatchDesignsByDesignApiArg
      >({
        query: (queryArg) => ({
          url: `/designs/${queryArg.design}`,
          method: 'PATCH',
          body: queryArg.body,
        }),
        invalidatesTags: ['Designs', ' Product Variants', 'UpdateDesign'],
      }),
      postDesignsByDesignDuplicate: build.mutation<
        PostDesignsByDesignDuplicateApiResponse,
        PostDesignsByDesignDuplicateApiArg
      >({
        query: (queryArg) => ({
          url: `/designs/${queryArg.design}/duplicate`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['Designs', 'DuplicateDesign'],
      }),
      postDesignsByDesignReassign: build.mutation<
        PostDesignsByDesignReassignApiResponse,
        PostDesignsByDesignReassignApiArg
      >({
        query: (queryArg) => ({
          url: `/designs/${queryArg.design}/reassign`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['Designs', 'ReassignDesign'],
      }),
      getDesignsByDesignValidate: build.query<
        GetDesignsByDesignValidateApiResponse,
        GetDesignsByDesignValidateApiArg
      >({
        query: (queryArg) => ({
          url: `/designs/${queryArg.design}/validate`,
          params: {
            component_to_replace_id: queryArg.componentToReplaceId,
            replacement_product_variant_id:
              queryArg.replacementProductVariantId,
          },
        }),
        providesTags: ['Designs', 'ValidateDesign'],
      }),
      getProductVariants: build.query<
        GetProductVariantsApiResponse,
        GetProductVariantsApiArg
      >({
        query: (queryArg) => ({
          url: '/product-variants',
          params: {
            search: queryArg.search,
            product_type: queryArg.productType,
            parent_product_variant_id: queryArg.parentProductVariantId,
            page: queryArg.page,
            perPage: queryArg.perPage,
          },
        }),
        providesTags: ['Product Variants', 'ListProductVariants'],
      }),
      getProducts: build.query<GetProductsApiResponse, GetProductsApiArg>({
        query: (queryArg) => ({
          url: '/products',
          params: { page: queryArg.page, perPage: queryArg.perPage },
        }),
        providesTags: ['Products', 'ListProducts'],
      }),
      getProjects: build.query<GetProjectsApiResponse, GetProjectsApiArg>({
        query: (queryArg) => ({
          url: '/projects',
          params: {
            search: queryArg.search,
            sortBy: queryArg.sortBy,
            sortDirection: queryArg.sortDirection,
            page: queryArg.page,
            perPage: queryArg.perPage,
            organisations: queryArg.organisations,
          },
        }),
        providesTags: ['Projects', 'ListProjects'],
      }),
      postProjects: build.mutation<PostProjectsApiResponse, PostProjectsApiArg>(
        {
          query: (queryArg) => ({
            url: '/projects',
            method: 'POST',
            body: queryArg.body,
          }),
          invalidatesTags: ['Projects', 'CreateProject'],
        },
      ),
      getProjectsByProject: build.query<
        GetProjectsByProjectApiResponse,
        GetProjectsByProjectApiArg
      >({
        query: (queryArg) => ({ url: `/projects/${queryArg.project}` }),
        providesTags: ['Projects', 'ShowProject'],
      }),
      putProjectsByProject: build.mutation<
        PutProjectsByProjectApiResponse,
        PutProjectsByProjectApiArg
      >({
        query: (queryArg) => ({
          url: `/projects/${queryArg.project}`,
          method: 'PUT',
          body: queryArg.body,
        }),
        invalidatesTags: ['Projects', 'UpdateProject'],
      }),
      deleteProjectsByProject: build.mutation<
        DeleteProjectsByProjectApiResponse,
        DeleteProjectsByProjectApiArg
      >({
        query: (queryArg) => ({
          url: `/projects/${queryArg.project}`,
          method: 'DELETE',
          body: queryArg.body,
        }),
        invalidatesTags: ['Projects', 'DeleteProject'],
      }),
      postProjectsByProjectDuplicate: build.mutation<
        PostProjectsByProjectDuplicateApiResponse,
        PostProjectsByProjectDuplicateApiArg
      >({
        query: (queryArg) => ({
          url: `/projects/${queryArg.project}/duplicate`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['Projects', 'DuplicateProject'],
      }),
      postReportsByDesignPreview: build.mutation<
        PostReportsByDesignPreviewApiResponse,
        PostReportsByDesignPreviewApiArg
      >({
        query: (queryArg) => ({
          url: `/reports/${queryArg.design}/preview`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['Reports', 'ShowReportPDF'],
      }),
      getSubstrates: build.query<GetSubstratesApiResponse, GetSubstratesApiArg>(
        {
          query: () => ({ url: '/substrates' }),
          providesTags: ['Substrates', 'ListSubstrates'],
        },
      ),
      getCustomerUsers: build.query<
        GetCustomerUsersApiResponse,
        GetCustomerUsersApiArg
      >({
        query: (queryArg) => ({
          url: '/customer-users',
          params: {
            search: queryArg.search,
            sortBy: queryArg.sortBy,
            sortDirection: queryArg.sortDirection,
            page: queryArg.page,
            perPage: queryArg.perPage,
            customer_id: queryArg.customerId,
          },
        }),
        providesTags: ['Users', 'ListCustomerUsers'],
      }),
      postCustomerUsers: build.mutation<
        PostCustomerUsersApiResponse,
        PostCustomerUsersApiArg
      >({
        query: (queryArg) => ({
          url: '/customer-users',
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['Users', 'InviteCustomerUser'],
      }),
      getCustomerUsersByUser: build.query<
        GetCustomerUsersByUserApiResponse,
        GetCustomerUsersByUserApiArg
      >({
        query: (queryArg) => ({ url: `/customer-users/${queryArg.user}` }),
        providesTags: ['Users', 'ShowCustomerUser'],
      }),
      deleteCustomerUsersByUser: build.mutation<
        DeleteCustomerUsersByUserApiResponse,
        DeleteCustomerUsersByUserApiArg
      >({
        query: (queryArg) => ({
          url: `/customer-users/${queryArg.user}`,
          method: 'DELETE',
          body: queryArg.body,
        }),
        invalidatesTags: ['Users', 'DeleteCustomerUsers'],
      }),
      patchCustomerUsersByUser: build.mutation<
        PatchCustomerUsersByUserApiResponse,
        PatchCustomerUsersByUserApiArg
      >({
        query: (queryArg) => ({
          url: `/customer-users/${queryArg.user}`,
          method: 'PATCH',
          body: queryArg.body,
        }),
        invalidatesTags: ['Users', 'UpdateCustomerUser'],
      }),
    }),
    overrideExisting: false,
  })
export { injectedRtkApi as serverApi }
export type PostAuthLoginApiResponse = /** status 200 Return the user


`UserWithCustomerResource` */ {
  data: UserWithCustomerResource;
};
export type PostAuthLoginApiArg = {
  body: {
    email: string;
    password: string;
    rememberMe?: boolean;
  };
};
export type PostAuthSignupApiResponse = /** status 200  */ string;
export type PostAuthSignupApiArg = {
  body: {
    company: string;
    name: string;
    email: string;
  };
};
export type PostAuthVerifyEmailApiResponse = /** status 200 Return user resource


`UserWithCustomerResource` */ {
  data: UserWithCustomerResource;
};
export type PostAuthVerifyEmailApiArg = {
  body: {
    email: string;
    name?: string;
    password: string;
    token: string;
    password_confirmation: string;
  };
};
export type PostAuthForgotPasswordApiResponse = /** status 200  */ string;
export type PostAuthForgotPasswordApiArg = {
  body: {
    email: string;
  };
};
export type PostAuthResetPasswordApiResponse =
  /** status 204 No content */ Blob;
export type PostAuthResetPasswordApiArg = {
  body: {
    email: string;
    password: string;
    token: string;
    password_confirmation: string;
  };
};
export type PostProfileVerifyEmailChangeApiResponse =
  /** status 200 Return user resource


`UserWithCustomerResource` */ {
    data: UserWithCustomerResource;
  };
export type PostProfileVerifyEmailChangeApiArg = {
  body: {
    email: string;
    token: string;
  };
};
export type GetAuthSessionApiResponse =
  /** status 200 `UserWithCustomerResource` */ {
    data: UserWithCustomerResource;
  };
export type GetAuthSessionApiArg = void;
export type DeleteAuthLogoutApiResponse = /** status 200 No content */ Blob;
export type DeleteAuthLogoutApiArg = {
  body: object;
};
export type PatchProfileDetailsApiResponse =
  /** status 200 `ViewUserResource` */ {
    data: ViewUserResource;
  };
export type PatchProfileDetailsApiArg = {
  body: {
    name: string;
    email: string;
  };
};
export type PatchProfilePasswordApiResponse =
  /** status 200 `ViewUserResource` */ {
    data: ViewUserResource;
  };
export type PatchProfilePasswordApiArg = {
  body: {
    current_password: string;
    new_password: string;
    new_password_confirmation: string;
  };
};
export type PatchProfilePictureApiResponse = /** status 200  */ string;
export type PatchProfilePictureApiArg = {
  body: {
    profile_picture: {
      key: string;
      uuid: string;
    };
  };
};
export type PostComponentsApiResponse = /** status 200 `ComponentResource` */ {
  data: ComponentResource;
};
export type PostComponentsApiArg = {
  body: {
    design_id: string;
    product_variant_id?: string;
    parent_id?: string;
    type: 'concrete_slab' | 'product_variant' | 'group';
    position?: {
      x?: number;
      y?: number;
      z?: number;
    };
    concrete_slab?: {
      strength?:
        | 'C12/15'
        | 'C20/25'
        | 'C25/30'
        | 'C30/37'
        | 'C35/45'
        | 'C40/50'
        | 'C45/55'
        | 'C50/60'
        | 'C55/67'
        | '>=C60/75';
      cracked?: boolean;
      thickness?: number;
      edge_distance_x_pos?: number;
      edge_distance_x_neg?: number;
      edge_distance_y_pos?: number;
      edge_distance_y_neg?: number;
      reinforcement?: boolean;
      reinforcement_diameter?: number;
      reinforcement_spacing?: number;
    };
    cast_in_anchor_channel?: {
      length?: number;
      custom_length?: number;
    };
    t_bolt?: {
      shear_force?: number;
      tension_force?: number;
      diameter?: string;
      length?: string;
      stand_off_distance?: number;
    };
  };
};
export type PostComponentsTbGroupApiResponse =
  /** status 200 Array of `ComponentResource` */ {
    data: ComponentResource[];
  };
export type PostComponentsTbGroupApiArg = {
  body: {
    design_id: string;
    parent_id: string;
    count: number;
  };
};
export type PatchComponentsByComponentApiResponse =
  /** status 200 `ComponentResource` */ {
    data: ComponentResource;
  };
export type PatchComponentsByComponentApiArg = {
  /** The component ID */
  component: string;
  body: {
    position?: {
      x?: number;
      y?: number;
      z?: number;
    };
    concrete_slab?: {
      strength?:
        | 'C12/15'
        | 'C20/25'
        | 'C25/30'
        | 'C30/37'
        | 'C35/45'
        | 'C40/50'
        | 'C45/55'
        | 'C50/60'
        | 'C55/67'
        | '>=C60/75';
      cracked?: boolean;
      thickness?: number;
      edge_distance_x_pos?: number;
      edge_distance_x_neg?: number;
      edge_distance_y_pos?: number;
      edge_distance_y_neg?: number;
      is_thickness_infinite?: boolean;
      is_edge_distance_x_pos_infinite?: boolean;
      is_edge_distance_x_neg_infinite?: boolean;
      is_edge_distance_y_pos_infinite?: boolean;
      is_edge_distance_y_neg_infinite?: boolean;
      has_splitting_reinforcement?: boolean;
      has_dense_reinforcement?: boolean;
      has_widely_spaced_reinforcement?: boolean;
      edge_reinforcement_type?: EdgeReinforcementType;
    };
    cast_in_anchor_channel?: {
      length?: any;
      custom_length?: any;
      anchor_spacings?: string;
      fixing_position?: FixingPosition;
      has_lever_arm?: boolean;
      has_custom_anchor_spacings?: boolean;
      lever_arm_distance?: number;
      lever_arm_degree_of_restraint?: number;
    };
    t_bolt?: {
      shear_force?: number;
      tension_force?: number;
      length?: any;
      diameter?: any;
      stand_off_distance?: number;
    };
  };
};
export type DeleteComponentsByComponentApiResponse =
  /** status 204 No content */ Blob;
export type DeleteComponentsByComponentApiArg = {
  /** The component ID */
  component: string;
  body: object;
};
export type PatchComponentsByComponentReplaceCastInChannelApiResponse =
  /** status 200 `DesignDetailResource` */ {
    data: DesignDetailResource;
  };
export type PatchComponentsByComponentReplaceCastInChannelApiArg = {
  /** The component ID */
  component: string;
  body: {
    /** Cast-in Channel Details */
    new_product_variant_id: string;
    /** T Bolt Details */
    t_bolt?: {
      variant_id?: string;
      diameter?: string;
    };
  };
};
export type PatchComponentsByComponentReplaceTBoltApiResponse =
  /** status 200 `DesignDetailResource` */ {
    data: DesignDetailResource;
  };
export type PatchComponentsByComponentReplaceTBoltApiArg = {
  /** The component ID */
  component: string;
  body: {
    new_product_variant_id: string;
  };
};
export type GetCustomersApiResponse =
  /** status 200 Paginated set of `CustomerResource` */ {
    data: CustomerResource[];
    links: {
      first: any;
      last: any;
      prev: any;
      next: any;
    };
    meta: {
      current_page: number;
      from: any;
      last_page: number;
      /** Generated paginator links. */
      links: {
        url: any;
        label: string;
        active: boolean;
      }[];
      /** Base path for paginator generated URLs. */
      path: any;
      /** Number of items shown per page. */
      per_page: number;
      /** Number of the last item in the slice. */
      to: any;
      /** Total number of items being paginated. */
      total: number;
    };
  };
export type GetCustomersApiArg = {
  search?: any;
  sortBy?: any;
  sortDirection?: SortDirection;
  page?: any;
  perPage?: any;
};
export type PostCustomersApiResponse = /** status 200 `CustomerResource` */ {
  data: CustomerResource;
};
export type PostCustomersApiArg = {
  body: {
    name: string;
    website: string;
    address_line_1: string;
    address_line_2?: any;
    city: string;
    county: string;
    postcode: string;
    initial_user_email?: any;
    initial_user_name?: any;
    logo?: string[];
  };
};
export type GetCustomersByCustomerApiResponse =
  /** status 200 `CustomerResource` */ {
    data: CustomerResource;
  };
export type GetCustomersByCustomerApiArg = {
  /** The customer ID */
  customer: string;
};
export type PatchCustomersByCustomerApiResponse =
  /** status 200 `CustomerResource` */ {
    data: CustomerResource;
  };
export type PatchCustomersByCustomerApiArg = {
  /** The customer ID */
  customer: string;
  body: {
    name: string;
    website?: any;
    address_line_1?: any;
    address_line_2?: any;
    city?: any;
    county?: any;
    postcode?: any;
    logo?: string[];
  };
};
export type DeleteCustomersByCustomerApiResponse =
  /** status 204 No content */ Blob;
export type DeleteCustomersByCustomerApiArg = {
  /** The customer ID */
  customer: string;
  body: object;
};
export type GetDesignsApiResponse =
  /** status 200 Paginated set of `DesignResource` */ {
    data: DesignResource[];
    links: {
      first: any;
      last: any;
      prev: any;
      next: any;
    };
    meta: {
      current_page: number;
      from: any;
      last_page: number;
      /** Generated paginator links. */
      links: {
        url: any;
        label: string;
        active: boolean;
      }[];
      /** Base path for paginator generated URLs. */
      path: any;
      /** Number of items shown per page. */
      per_page: number;
      /** Number of the last item in the slice. */
      to: any;
      /** Total number of items being paginated. */
      total: number;
    };
  };
export type GetDesignsApiArg = {
  projectId?: any;
  search?: any;
  sortBy?: any;
  sortDirection?: SortDirection;
  page?: any;
  perPage?: any;
};
export type PostDesignsApiResponse = /** status 201 `DesignResource` */ {
  data: DesignResource;
};
export type PostDesignsApiArg = {
  body: {
    project_id?: any;
  };
};
export type GetDesignsGroupedByProjectsApiResponse =
  /** status 200 Array of `ProjectWithOrderedDesignsResource` */ {
    data: ProjectWithOrderedDesignsResource[];
  };
export type GetDesignsGroupedByProjectsApiArg = {
  projectId?: any;
  search?: any;
  sortBy?: any;
  sortDirection?: SortDirection;
  page?: any;
  perPage?: any;
};
export type GetDesignsByDesignApiResponse =
  /** status 200 `DesignDetailResource` */ {
    data: DesignDetailResource;
  };
export type GetDesignsByDesignApiArg = {
  /** The design ID */
  design: string;
};
export type DeleteDesignsByDesignApiResponse =
  /** status 204 No content */ Blob;
export type DeleteDesignsByDesignApiArg = {
  /** The design ID */
  design: string;
  body: object;
};
export type PatchDesignsByDesignApiResponse =
  /** status 200 `DesignResource` */ {
    data: DesignResource;
  };
export type PatchDesignsByDesignApiArg = {
  /** The design ID */
  design: string;
  body: {
    name: string;
  };
};
export type PostDesignsByDesignDuplicateApiResponse =
  /** status 201 `DesignResource` */ {
    data: DesignResource;
  };
export type PostDesignsByDesignDuplicateApiArg = {
  /** The design ID */
  design: string;
  body: {
    project_id: string;
    name: string;
  };
};
export type PostDesignsByDesignReassignApiResponse =
  /** status 200 `DesignResource` */ {
    data: DesignResource;
  };
export type PostDesignsByDesignReassignApiArg = {
  /** The design ID */
  design: string;
  body: {
    project_id: string;
  };
};
export type GetDesignsByDesignValidateApiResponse = /** status 200  */
  | {
      data: DesignValidationResultResource;
    }
  | {
      data: DesignValidationResultResource;
    };
export type GetDesignsByDesignValidateApiArg = {
  /** The design ID */
  design: string;
  componentToReplaceId?: any;
  replacementProductVariantId?: any;
};
export type GetProductVariantsApiResponse =
  /** status 200 Array of `ProductVariantResource` */ {
    data: ProductVariantResource[];
  };
export type GetProductVariantsApiArg = {
  search?: any;
  productType?: any;
  parentProductVariantId?: any;
  page?: any;
  perPage?: any;
};
export type GetProductsApiResponse =
  /** status 200 Array of `ProductResource` */ {
    data: ProductResource[];
  };
export type GetProductsApiArg = {
  page?: any;
  perPage?: any;
};
export type GetProjectsApiResponse =
  /** status 200 Paginated set of `ProjectResource` */ {
    data: ProjectResource[];
    links: {
      first: any;
      last: any;
      prev: any;
      next: any;
    };
    meta: {
      current_page: number;
      from: any;
      last_page: number;
      /** Generated paginator links. */
      links: {
        url: any;
        label: string;
        active: boolean;
      }[];
      /** Base path for paginator generated URLs. */
      path: any;
      /** Number of items shown per page. */
      per_page: number;
      /** Number of the last item in the slice. */
      to: any;
      /** Total number of items being paginated. */
      total: number;
    };
  };
export type GetProjectsApiArg = {
  search?: any;
  sortBy?: any;
  sortDirection?: SortDirection;
  page?: any;
  perPage?: any;
  organisations?: string[];
};
export type PostProjectsApiResponse = /** status 201 `ProjectResource` */ {
  data: ProjectResource;
};
export type PostProjectsApiArg = {
  body: {
    customer_id: string;
    name: string;
  };
};
export type GetProjectsByProjectApiResponse =
  /** status 200 `ProjectResource` */ {
    data: ProjectResource;
  };
export type GetProjectsByProjectApiArg = {
  /** The project ID */
  project: string;
};
export type PutProjectsByProjectApiResponse =
  /** status 200 `ProjectResource` */ {
    data: ProjectResource;
  };
export type PutProjectsByProjectApiArg = {
  /** The project ID */
  project: string;
  body: {
    name: string;
  };
};
export type DeleteProjectsByProjectApiResponse = /** status 200  */ {
  message: string;
};
export type DeleteProjectsByProjectApiArg = {
  /** The project ID */
  project: string;
  body: object;
};
export type PostProjectsByProjectDuplicateApiResponse =
  /** status 201 `ProjectResource` */ {
    data: ProjectResource;
  };
export type PostProjectsByProjectDuplicateApiArg = {
  /** The project ID */
  project: string;
  body: {
    name: string;
  };
};
export type PostReportsByDesignPreviewApiResponse = /** status 200  */ {
  url: string;
};
export type PostReportsByDesignPreviewApiArg = {
  /** The design ID */
  design: string;
  body: {
    revision_name?: any;
    design_notes?: any;
  };
};
export type GetSubstratesApiResponse = /** status 200 `SubstrateResource` */ {
  data: SubstrateResource;
};
export type GetSubstratesApiArg = void;
export type GetCustomerUsersApiResponse =
  /** status 200 Paginated set of `ViewUserResource` */ {
    data: ViewUserResource[];
    links: {
      first: any;
      last: any;
      prev: any;
      next: any;
    };
    meta: {
      current_page: number;
      from: any;
      last_page: number;
      /** Generated paginator links. */
      links: {
        url: any;
        label: string;
        active: boolean;
      }[];
      /** Base path for paginator generated URLs. */
      path: any;
      /** Number of items shown per page. */
      per_page: number;
      /** Number of the last item in the slice. */
      to: any;
      /** Total number of items being paginated. */
      total: number;
    };
  };
export type GetCustomerUsersApiArg = {
  search?: any;
  sortBy?: any;
  sortDirection?: SortDirection;
  page?: any;
  perPage?: any;
  customerId?: string;
};
export type PostCustomerUsersApiResponse = /** status 200  */ {
  message: string;
};
export type PostCustomerUsersApiArg = {
  body: {
    emails?: any;
    customer_id: string;
    owner_email?: any;
  };
};
export type GetCustomerUsersByUserApiResponse =
  /** status 200 `UserWithCustomerResource` */ {
    data: UserWithCustomerResource;
  };
export type GetCustomerUsersByUserApiArg = {
  /** The user ID */
  user: string;
};
export type DeleteCustomerUsersByUserApiResponse =
  /** status 204 No content */ Blob;
export type DeleteCustomerUsersByUserApiArg = {
  /** The user ID */
  user: string;
  body: object;
};
export type PatchCustomerUsersByUserApiResponse =
  /** status 200 `ViewUserResource` */ {
    data: ViewUserResource;
  };
export type PatchCustomerUsersByUserApiArg = {
  /** The user ID */
  user: string;
  body: {
    customer_id: string;
    name?: any;
    email?: any;
  };
};
export type CustomerResource = {
  id: string;
  name: string;
  website: string;
  address_line_1: string;
  address_line_2: string;
  city: string;
  postcode: string;
  county: string;
  created_at: string;
  has_owner: string;
  /** if the customer has projects associated with it */
  has_designs: boolean;
  /** if the customer has designs associated with it */
  has_projects: boolean;
  logo_url: string;
};
export type UserWithCustomerResource = {
  id: string;
  name: string;
  email: string;
  is_admin: string;
  is_owner: string;
  profile_picture_url: string;
  customer: CustomerResource;
};
export type ViewUserResource = {
  id: string;
  first_name: string;
  name: string;
  email: string;
  profile_picture_url: string;
  customer: CustomerResource;
  is_owner: string;
  created_at: string;
  invite_accepted_at: string;
};
export type ComponentResource = {
  id: string;
  group_id: string;
  type: string;
  model: string;
  product_variant_id?: string;
  parent_id?: string;
  position?: {
    x: number;
    y: number;
    z: number;
  };
  concrete_slab?: {
    strength: string;
    cracked: boolean;
    thickness: number;
    edge_distance_x_pos: number;
    edge_distance_x_neg: number;
    edge_distance_y_pos: number;
    edge_distance_y_neg: number;
    is_thickness_infinite: boolean;
    is_edge_distance_x_pos_infinite: boolean;
    is_edge_distance_x_neg_infinite: boolean;
    is_edge_distance_y_pos_infinite: boolean;
    is_edge_distance_y_neg_infinite: boolean;
    has_splitting_reinforcement: boolean;
    has_dense_reinforcement: boolean;
    has_widely_spaced_reinforcement: boolean;
    edge_reinforcement_type: string;
  };
  cast_in_anchor_channel?: {
    length: any;
    custom_length: any;
    anchor_spacings: number[];
    fixing_position: any;
    has_lever_arm: boolean;
    has_custom_anchor_spacings: boolean;
    lever_arm_distance: number;
    lever_arm_degree_of_restraint: string;
  };
  t_bolt?: {
    shear_force: string;
    tension_force: string;
    diameter: string;
    stand_off_distance: string;
    length: number;
  };
};
export type EdgeReinforcementType =
  | 'none'
  | 'straight_edge'
  | 'straight_edge_with_stirrups';
export type FixingPosition = 'top' | 'face';
export type DesignDetailResource = {
  id: string;
  name: string;
  thumbnail_url: string;
  project_id: string;
  updated_at: string;
  created_at: string;
  components: ComponentResource[];
};
export type SortDirection = 'asc' | 'desc';
export type DesignResource = {
  id: string;
  name: string;
  thumbnail_url: string;
  project_id: string;
  updated_at: string;
  created_at: string;
};
export type ProjectWithOrderedDesignsResource = {
  id: string;
  name: string;
  customer: CustomerResource;
  designs: DesignResource[];
  has_more_designs: string;
  created_at: string;
  updated_at: string;
};
export type ValidationValueResource = {
  id: string;
  name: string;
  utilisation: string;
  error: string;
  message: string;
};
export type CastInChannelLengthResource = {
  length: string;
  number_of_anchors: string;
  anchor_spacing: string;
};
export type TBoltDiameterResource = {
  name: string;
  tension_characteristic_resistance: string;
  tension_partial_factor: string;
};
export type ProductVariantResource = {
  id: string;
  vendor_id: string;
  vendor_name: string;
  product_id: string;
  product_name: string;
  product_type: string;
  product_material: string;
  name: string;
  compatible_children: ProductVariantResource[];
  cast_in_anchor_channel?: {
    depth: number;
    width: number;
    overhang: number;
    anchor_spacing_min: number;
    anchor_spacing_max: number;
    anchor_head_diameter: number;
    anchor_head_thickness: number;
    anchor_length: number;
    anchor_shaft_diameter: number;
    lengths: CastInChannelLengthResource[];
  };
  t_bolt?: {
    diameters: TBoltDiameterResource[];
    lengths: number[];
    lip_height: number;
  };
};
export type ConfigurationValidationResultResource = {
  variant: ProductVariantResource;
  validation_result: ValidationValueResource[];
  t_bolt?: {
    diameter: TBoltDiameterResource;
  };
};
export type DesignValidationResultResource = {
  validation_to_display: ValidationValueResource[];
  optimal_configuration: ConfigurationValidationResultResource;
  alternative_configurations: ConfigurationValidationResultResource[];
};
export type ProductResource = {
  id: string;
  vendor_id: string;
  name: string;
  type: string;
  link: string;
  image: string;
  model: string;
};
export type ProjectResource = {
  id: string;
  name: string;
  customer: CustomerResource;
  designs_count: string;
  created_at: string;
  updated_at: string;
  /** if the project has designs associated with it */
  has_designs: boolean;
};
export type ConcreteStrength =
  | 'C12/15'
  | 'C20/25'
  | 'C25/30'
  | 'C30/37'
  | 'C35/45'
  | 'C40/50'
  | 'C45/55'
  | 'C50/60'
  | 'C55/67'
  | '>=C60/75';
export type SubstrateResource = {
  concrete: {
    strengths: ConcreteStrength[];
  };
};
export const {
  usePostAuthLoginMutation,
  usePostAuthSignupMutation,
  usePostAuthVerifyEmailMutation,
  usePostAuthForgotPasswordMutation,
  usePostAuthResetPasswordMutation,
  usePostProfileVerifyEmailChangeMutation,
  useGetAuthSessionQuery,
  useLazyGetAuthSessionQuery,
  useDeleteAuthLogoutMutation,
  usePatchProfileDetailsMutation,
  usePatchProfilePasswordMutation,
  usePatchProfilePictureMutation,
  usePostComponentsMutation,
  usePostComponentsTbGroupMutation,
  usePatchComponentsByComponentMutation,
  useDeleteComponentsByComponentMutation,
  usePatchComponentsByComponentReplaceCastInChannelMutation,
  usePatchComponentsByComponentReplaceTBoltMutation,
  useGetCustomersQuery,
  useLazyGetCustomersQuery,
  usePostCustomersMutation,
  useGetCustomersByCustomerQuery,
  useLazyGetCustomersByCustomerQuery,
  usePatchCustomersByCustomerMutation,
  useDeleteCustomersByCustomerMutation,
  useGetDesignsQuery,
  useLazyGetDesignsQuery,
  usePostDesignsMutation,
  useGetDesignsGroupedByProjectsQuery,
  useLazyGetDesignsGroupedByProjectsQuery,
  useGetDesignsByDesignQuery,
  useLazyGetDesignsByDesignQuery,
  useDeleteDesignsByDesignMutation,
  usePatchDesignsByDesignMutation,
  usePostDesignsByDesignDuplicateMutation,
  usePostDesignsByDesignReassignMutation,
  useGetDesignsByDesignValidateQuery,
  useLazyGetDesignsByDesignValidateQuery,
  useGetProductVariantsQuery,
  useLazyGetProductVariantsQuery,
  useGetProductsQuery,
  useLazyGetProductsQuery,
  useGetProjectsQuery,
  useLazyGetProjectsQuery,
  usePostProjectsMutation,
  useGetProjectsByProjectQuery,
  useLazyGetProjectsByProjectQuery,
  usePutProjectsByProjectMutation,
  useDeleteProjectsByProjectMutation,
  usePostProjectsByProjectDuplicateMutation,
  usePostReportsByDesignPreviewMutation,
  useGetSubstratesQuery,
  useLazyGetSubstratesQuery,
  useGetCustomerUsersQuery,
  useLazyGetCustomerUsersQuery,
  usePostCustomerUsersMutation,
  useGetCustomerUsersByUserQuery,
  useLazyGetCustomerUsersByUserQuery,
  useDeleteCustomerUsersByUserMutation,
  usePatchCustomerUsersByUserMutation,
} = injectedRtkApi
